module.exports = __webpack_public_path__ + "static/media/004-book.6271a373.svg";